import { useContext } from 'react'
import {
  LidarUploadContext,
  type LidarUploadContextValue,
} from '../Contexts/LidarUploadContext'

export const useLidarUpload = (): LidarUploadContextValue => {
  const ctx = useContext(LidarUploadContext)
  if (!ctx) {
    throw new Error('useLidarUpload must be used within a LidarUploadProvider')
  }
  return ctx
}
